export default __webpack_public_path__ + "static/media/FrankHomies.82c0ff5d.jpg";